module.exports = {"notifications":"Notificaciones"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Notifications.json
// module id = 608
// module chunks = 1